import type { ChatIntegrationObjectItem } from "schemas/generated/chatMessage";

import React from "react";

import { Image } from "lucide-react";

export const IntegrationObjectToken: React.FC<{
  data: ChatIntegrationObjectItem;
}> = ({ data }) => {
  return (
    <span className="inline-flex items-center align-middle max-w-full p-1 border-[0.5px] border-border bg-sheet rounded-md">
      {data.object.imageUrl ? (
        <img
          src={data.object.imageUrl}
          alt={data.object.title ?? ""}
          className="w-5 h-5 object-cover rounded-sm inline align-baseline mr-1 border border-border"
        />
      ) : (
        <Image className="w-5 h-5 object-cover text-placeholder rounded-sm inline align-baseline mr-1 border border-border" />
      )}
      <span className="font-medium text-default truncate">
        {data.object.title ?? data.object.id}
      </span>
    </span>
  );
};
